export default "__VITE_ASSET__7226317f__"